// extracted by mini-css-extract-plugin
export default {"wrapper":"omTri","wrapper-content":"mdZMP","title-skeleton":"P2lWD","image-wrapper":"Ioyta"};